import { render } from "./AddPlatFormShop.vue?vue&type=template&id=6f75410c&scoped=true"
import script from "./AddPlatFormShop.vue?vue&type=script&lang=js"
export * from "./AddPlatFormShop.vue?vue&type=script&lang=js"

import "./AddPlatFormShop.vue?vue&type=style&index=0&id=6f75410c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f75410c"]])

export default __exports__